export default "__VITE_ASSET__BObv4uRq__"